import RegistrationComplete from '../../../components/pages/users/RegistrationComplete.vue'

export default {
  components: { RegistrationComplete }
}
